import { cast, types } from 'mobx-state-tree';

import { IPmPayload } from '../../models/models';

export const SavePMChecklist = types
  .model({
    isChanged: types.boolean,
    tempData: types.maybeNull(
      types.array(
        types.model({
          assetCategoryInspectionTypeCheckListId: types.maybeNull(types.number),
          isActive: types.maybeNull(types.boolean),
          pk_uuid: types.maybeNull(types.string),
          isCompleted: types.maybeNull(types.boolean),
          comments: types.maybeNull(types.string),
          isChanged: types.maybeNull(types.boolean),
          pkAssetInspectionPMChecklist: types.maybeNull(types.number),
          isCommentChange: types.maybeNull(types.boolean),
          isCompletedChange: types.maybeNull(types.boolean),
          inspectionId: types.maybeNull(types.number),
        }),
      ),
    ),
  })
  .views(self => ({
    get isChangedTrue() {
      return self.isChanged;
    },
    get PMcheckListData() {
      return self.tempData?.toJSON();
    },
  }))
  .actions(self => ({
    setIsChanged: (data: boolean) => {
      self.isChanged = data;
    },
    setDiscardData: (discardData: IPmPayload[]) => {
      self.tempData = cast(discardData);
    },
  }));

export default SavePMChecklist;
